import { render, staticRenderFns } from "./ZarinpalSettings.vue?vue&type=template&id=0d9cbc72&scoped=true&"
import script from "./ZarinpalSettings.vue?vue&type=script&lang=js&"
export * from "./ZarinpalSettings.vue?vue&type=script&lang=js&"
import style0 from "./ZarinpalSettings.vue?vue&type=style&index=0&id=0d9cbc72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9cbc72",
  null
  
)

export default component.exports